
import  axios  from 'axios';
import AppUtils from "../../../utils/AppUtils";
import {CLEAR_A_TOWJOB_ERROR_MESSAGE} from "../towjob/actions";


export const LOAD_COMPANY_DATA = 'company/LOAD_COMPANY_DATA';
export const DELETE_A_COMPANY = 'company/DELETE_A_COMPANY';
export const SAVE_A_COMPANY = 'company/SAVE_A_COMPANY';
export const UPDATE_A_COMPANY = 'company/UPDATE_A_COMPANY';
export const SELECT_A_COMPANY = 'company/SELECT_A_COMPANY';
export const CLEAR_A_COMPANY_ERROR_MESSAGE = 'company/CLEAR_A_COMPANY_ERROR_MESSAGE';



export function clearCompanyErrorMsgInStore(){
    return {
        type: CLEAR_A_COMPANY_ERROR_MESSAGE,
        
    }
}

export function loadCompanyDataInStore(argCompanyDataArray) {
    return {
        type: LOAD_COMPANY_DATA,
        companysData:argCompanyDataArray
    }
}
export function deleteACompanyDataInStore(argDeleteResponse, argErrorMsg) {
    return {
        type: DELETE_A_COMPANY,
        deleteCompanyResponse:argDeleteResponse,
        errorMsg:argErrorMsg
    }
}

export function saveACompanyDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: SAVE_A_COMPANY,
        saveCompanyResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

export function updateACompanyDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: UPDATE_A_COMPANY,
        updateCompanyResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}



export function selectACompanyInStore(argCompany  ) {
    return {
        type: SELECT_A_COMPANY,
        selectACompanyResponse:argCompany

    }
}

/********************* End of InStore calls **************************/

//****************************************
//Below is for update a Stream
//****************************************
export function clearCompanyErrorMsg(){
    return (dispatch, getState) => {
        dispatch(clearCompanyErrorMsgInStore());
    }
}


export function updateACompany(argURL, argCamera) {
    return (dispatch, getState) => {
        const state = getState();
        updateACompanyOnServer(argURL, argCamera, state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){

            dispatch(saveACompanyDataInStore(saveResponse.data, {"status":saveResponse.status, "statusText":saveResponse.statusText}));

        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            console.log("I had an error updating a company" + errorObj.statusText + errorObj.status);
            dispatch(saveACompanyDataInStore({}, errorObj));
        });
    }//end of return
}


function updateACompanyOnServer( argURL, argCamera, argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPutsForUpdateACompany(argURL, argCamera , argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                //console.log("Farshid some error occured on saving a companys " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPutsForUpdateACompany(argURL, argCamera , argIdToken, argUserId){
    /*
     I build something like this :
     http://localhost:4567/companys
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies";
    console.log(" on posting a companyies the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.put(baseUrl,argCamera, {headers: {"Authorization" : `Bearer ${argIdToken}`}} ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for select a  Company
//****************************************
export function selectACompany( argCompany) {
    return (dispatch, getState) => {

            dispatch(selectACompanyInStore(argCompany, {}));


    }//end of return
}





//****************************************
//Below is for save a Stream
//****************************************
export function saveACompany(argURL, argCamera) {
    return (dispatch, getState) => {
        const state = getState();
        saveACompanyOnServer(argURL, argCamera,  state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){

            dispatch(saveACompanyDataInStore(saveResponse.data, {"status":saveResponse.status, "statusText":saveResponse.statusText}));

        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            console.log("I had an error saving a Company lot" + + errorObj.statusText + errorObj.status);
            dispatch(saveACompanyDataInStore({},errorObj));
        });
    }//end of return
}


function saveACompanyOnServer( argURL, argCamera, argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPostsForSaveACompany(argURL, argCamera, argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                console.log("Farshid some error occured on saving a companys " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPostsForSaveACompany(argURL, argCamera, argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/companys
     */

    let baseUrl = argURL+"users/"+argUserId+"/companies";
    console.log(" on posting a companyies the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.post(baseUrl,argCamera, {headers: {"Authorization" : `Bearer ${argIdToken}`}} ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for delete a company
//****************************************
export function deleteACompany(argURL, argCameraId) {
    return (dispatch, getState) => {
        const state = getState();
        deleteACompanyOnServer(argURL, argCameraId, state.login.loginData.idToken, state.user.saveUserResp.id).then(function(deleteResponse){

            dispatch(deleteACompanyDataInStore(deleteResponse.data, {"status":deleteResponse.status, "statusText":deleteResponse.statusText}));

        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            //console.log("I had an error deleteACompany" + err);
            dispatch(deleteACompanyDataInStore({}, err));
        });
    }//end of return
}


function deleteACompanyOnServer( argURL, argStreamId, argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){



        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfDeletesForDeleteACompany(argURL, argStreamId,  argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                //console.log("Farshid some error occured on deleteing a company " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfDeletesForDeleteACompany(argURL, argStreamId, argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/cameras
     */

    let baseUrl = argURL+"users/"+argUserId+"/companies"+"/"+argStreamId;
    console.log(" on deleteing a company the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.delete(baseUrl,{headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}


//Get list of companys

export function loadCompanysData(argURL) {
    return (dispatch, getState) => {
        const state = getState();
        getListOfCompanys(argURL, state.login.loginData.idToken, state.user.saveUserResp.id).then(function(companysList){

            dispatch(loadCompanyDataInStore(companysList));

    }, function(err){
        console.log("I had an error loadCompanysData" + err);
        });
    }//end of return
}

function getArrayOfGetsForListOfCompanys(argURL, argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/company
     */

    let baseUrl = argURL+"users/"+argUserId+"/companies";
    console.log(" on getting list of Companys  the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.get(baseUrl,{headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}

export function getListOfCompanys( argURL, argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfGetsForListOfCompanys(argURL, argIdToken, argUserId)).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on getting list of Companys " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}
//This is simialr but passing the user Id.
export function loadCompanysDataWithUserId(argURL, argUserId) {
    return (dispatch, getState) => {
        const state = getState();
        getListOfCompanys(argURL, state.login.loginData.idToken, argUserId).then(function(companysList){

            dispatch(loadCompanyDataInStore(companysList));

        }, function(err){
            console.log("I had an error loadCompanysDataWithUserId" + err);
        });
    }//end of return
}

/*
function getCompanyDataFromRemoteServer( argURL, argCompanysList  ){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if(argCompanysList != null){

            axios.all(getArrayOfGets(argURL, argCompanysList )).then(function(responses){
                resolve(responses);

            }, function(err) {
                console.log("Farshid some error occured " + err.message);
                reject(err);
            });
        }
    });

    return returnPromise;
}
*/

/*
function getArrayOfGets(argURL, argFarmsList ){

    //let baseUrl =  "http://innovasea-app-dev-1.eastus.cloudapp.azure.com:4567/METRIC_VALUES?";
    let baseUrl = argURL;



    var arrayOfGets = [];
    if(argFarmsList != null) {
        for (var i = 0; i < argFarmsList.length; i++) {
                let responseData = argFarmsList[i];
                //let responseData = singleResponse.data;
                //if((argMetricList[i].checked != null) && (argMetricList[i].checked == true) ) {
                let tempURl = baseUrl + "GRAPHS" + "/farm_summary?farmId=" + responseData.id;
                console.log("Farshid the Company DATA URL is =" + tempURl);
                arrayOfGets.push(axios.get(tempURl));

            //}
        }
    }
    return arrayOfGets;


}
*/

/*
export function loadCompanyData(argURL) {
    return (dispatch, getState) => {


        var arrayOfCompanyData=[];
        getListOfCompanys(argURL).then(function(companysList){

            for(var z=0; z<companysList.length; z++){

                let singleResponse = companysList[z];
                let responseData = singleResponse.data;
                getCompanyDataFromRemoteServer(argURL,responseData ).then(function (farmsData){
                    for(var i=0; i<farmsData.length; i++) {
                        arrayOfCompanyData.push(farmsData[i].data);
                    }
                    dispatch(loadCompanyDataInStore(arrayOfCompanyData));

                }, function (err){
                    console.log("I had an error gettting Farms Data3333" + err);
                });

            }
    }, function(err){
        console.log("I had an error gettting Farms Data2" + err);
        });
    }//end of return
}
 */